import { FC } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Translate } from "@/components/Application/Translate";

// Your SVG as a React component
import LogoWhite from "@/assets/svg/logo/logo-Logo-Board-05.svg?react";

interface ILoadingProps {
  loading: boolean;
  showSpinner?: boolean; // optional
}

export const Loading: FC<ILoadingProps> = ({ loading, showSpinner = false, children }) => {
  if (!loading) return <>{children}</>;

  return (
    <Box
      display="grid"
      sx={{
        placeItems: "center",
        height: "100vh",
        width: "100vw",
        p: 2,
        bgcolor: "background.default",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        {/* Logo as React component */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
          <LogoWhite width="180px" height="100px" />
        </Box>

        {showSpinner && (
          <Box sx={{ mb: 2 }}>
            <CircularProgress size={22} />
          </Box>
        )}

        <Translate String="Application.Loading" HTMLTag="h1" className="heading">
          SATOS is loading
        </Translate>
      </Box>
    </Box>
  );
};
